import React from "react";
import { theme } from "../theme";

export const Card = ({ children, style = {} }) => (
  <div
    style={{
      background: theme.colors.card,
      border: `1px solid ${theme.colors.border}`,
      borderRadius: theme.radius.md,
      boxShadow: theme.shadow.soft,
      padding: "20px",
      ...style
    }}
  >
    {children}
  </div>
);

export const Button = ({
  children,
  variant = "primary",
  disabled = false,
  onClick,
  style = {}
}) => {
  const styles = {
    primary: {
      background: theme.colors.primary,
      color: "#fff",
      border: "none"
    },
    secondary: {
      background: "#fff",
      color: theme.colors.text,
      border: `1px solid ${theme.colors.border}`
    },
    danger: {
      background: "#fff",
      color: theme.colors.danger,
      border: `1px solid ${theme.colors.danger}`
    },
    warning: {
      background: theme.colors.warning,
      color: "#fff",
      border: "none"
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: "10px 14px",
        borderRadius: theme.radius.sm,
        fontWeight: "700",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        ...styles[variant],
        ...style
      }}
    >
      {children}
    </button>
  );
};

export const Badge = ({ children, tone = "default" }) => {
  const tones = {
    default: { bg: "#e5e7eb", text: "#374151" },
    draft: { bg: "#e0f2fe", text: "#075985" },
    review: { bg: "#fef3c7", text: "#92400e" },
    approved: { bg: "#d1fae5", text: "#166534" },
    published: { bg: "#ede9fe", text: "#5b21b6" }
  };

  const selected = tones[tone] || tones.default;

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: theme.radius.pill,
        background: selected.bg,
        color: selected.text,
        fontWeight: "700",
        fontSize: "12px"
      }}
    >
      {children}
    </span>
  );
};

export const Input = (props) => (
  <input
    {...props}
    style={{
      padding: "10px 12px",
      borderRadius: theme.radius.sm,
      border: `1px solid ${theme.colors.border}`,
      width: "100%",
      ...(props.style || {})
    }}
  />
);
export const Textarea = ({ style = {}, ...props }) => (
  <textarea
    {...props}
    style={{
      padding: "12px",
      borderRadius: theme.radius.sm,
      border: `1px solid ${theme.colors.border}`,
      width: "100%",
      resize: "vertical",
      fontFamily: "inherit",
      ...style
    }}
  />
);

export const Select = ({ children, style = {}, ...props }) => (
  <select
    {...props}
    style={{
      padding: "12px",
      borderRadius: theme.radius.sm,
      border: `1px solid ${theme.colors.border}`,
      width: "100%",
      background: "#ffffff",
      fontFamily: "inherit",
      ...style
    }}
  >
    {children}
  </select>
);